import { cn } from "@/lib/utils";
import { Card, Label, MonoMeta, StateWord, Track, WaitingChip } from "@/design/primitives";
import { STATE_WORD } from "./states";

const LINE = { healthy: "text-os-ink-2", broken: "text-os-ink", alert: "text-os-ink", stale: "text-os-ink", empty: "text-os-ink-3" };

export const WatchHeading = ({ name, brand, state, as: Title = "h3", className }) => (
  <div className={className}>
    <div className="flex items-baseline justify-between gap-3">
      <Title className="min-w-0 truncate text-[0.9375rem] font-semibold tracking-[-0.01em] text-os-ink">{name}</Title>
      <StateWord tone={STATE_WORD[state].tone}>{STATE_WORD[state].word}</StateWord>
    </div>
    <Label as="p" data-testid="tile-brand" className="mt-1">{brand}</Label>
  </div>
);

export const StateMessage = ({ state, line, className }) =>
  state === "waiting" ? (
    <div className={className}>
      <WaitingChip>{line}</WaitingChip>
    </div>
  ) : (
    <p data-testid="tile-state-line" className={cn("text-[0.875rem] leading-[1.45]", LINE[state], className)}>
      {line}
    </p>
  );

const BigNumber = ({ number, label }) => (
  <div data-testid="tile-big-number">
    <div className="text-[2.875rem] font-semibold leading-none tracking-[-0.035em] text-os-ink tabular-nums">{number}</div>
    <Label as="div" className="mt-2">{label}</Label>
  </div>
);

export const WatchTile = ({ tile, onOpen }) => {
  const { slug, name, brand, state, line, number, label, stamp, track } = tile;
  const open = () => onOpen(slug);
  return (
    <Card
      role="button"
      tabIndex={0}
      quiet={state === "empty"}
      data-testid={`tile-${slug}`}
      data-state={state}
      aria-label={`${name}, ${brand}. Open details`}
      onClick={open}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), open())}
      className="flex h-full cursor-pointer flex-col p-5 text-left hover:border-os-border-strong focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-os-ink"
    >
      <WatchHeading name={name} brand={brand} state={state} />
      <StateMessage state={state} line={line} className="mt-3 flex-1" />
      <div data-testid="tile-measure" className={cn("mt-4 border-t border-os-border pt-4", state === "stale" && "opacity-40")}>
        <BigNumber number={number} label={label} />
        <Track runs={track} emptyLabel="no runs yet" className="mt-4" />
      </div>
      <MonoMeta as="p" data-testid="tile-stamp" className="mt-3">{stamp}</MonoMeta>
    </Card>
  );
};
